import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Url } from '../url/url';


const NewsLetter = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [total, setTotal]             = useState(0);
  const [page, setPage]               = useState(1);
  const [pages, setPages]             = useState(1);
  const [search, setSearch]           = useState('');
  const [loading, setLoading]         = useState(false);

  const fetchSubscribers = async (pg, q) => {
    const pgNum = pg || 1;
    const qStr  = q  || '';
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${Url}/newsletter/all?page=${pgNum}&limit=20&search=${qStr}`,
      
      );
      setSubscribers(data.data);
      setTotal(data.total);
      setPages(data.pages);
      setPage(data.page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscribers(1, '');
  }, []);

  const handleSearch = (e) => {
    const q = e.target.value;
    setSearch(q);
    fetchSubscribers(1, q);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this subscriber?')) return;
    try {
      await axios.delete(`${Url}/newsletter/${id}`, { withCredentials: true });
      fetchSubscribers(page, search);
    } catch (err) {
      console.error(err);
    }
  };

  const handleExport = () => {
    window.open(`${Url}/newsletter/export`, '_blank');
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 className="mb-0">NewsLetter</h5>
          <small className="text-secondary">{total} total subscribers</small>
        </div>
        <button className="btn btn-dark btn-sm" onClick={handleExport}>
          Export CSV
        </button>
      </div>

      <div className="mb-3">
        <input
          type="search"
          className="form-control"
          placeholder="Search by email..."
          value={search}
          onChange={handleSearch}
          style={{ maxWidth: '320px' }}
        />
      </div>

      {loading ? (
        <p className="text-secondary">Loading...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Email</th>
                <th>Subscribed On</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {subscribers.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-secondary py-4">
                    No subscribers found
                  </td>
                </tr>
              ) : (
                subscribers.map((sub, i) => (
                  <tr key={sub._id}>
                    <td>{(page - 1) * 20 + i + 1}</td>
                    <td>{sub.email}</td>
                    <td>{new Date(sub.subscribedAt).toLocaleDateString('en-IN')}</td>
                    <td>
                      <span className={`badge ${sub.isActive ? 'bg-success' : 'bg-secondary'}`}>
                        {sub.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(sub._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {pages > 1 && (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page === 1}
            onClick={() => fetchSubscribers(page - 1, search)}
          >
            Prev
          </button>
          <span className="align-self-center small text-secondary">
            Page {page} of {pages}
          </span>
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page === pages}
            onClick={() => fetchSubscribers(page + 1, search)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsLetter;